import store from './store/index.js';
import BlueSearchApp from './BlueSearch.vue';
import SearchQuery from './components/query/Query.vue';
import SearchFilters from './components/filters/Filters.vue';
import SearchTags from './components/tags/Tags.vue';
import SearchResults from './components/results/Results.vue';
import SearchPagination from './components/pagination/Pagination.vue';

import { defaults } from 'lodash-es';

const plugin = {
  install(Vue, config) {
    let options = Object.fromEntries(
      Object.entries(config).map(([k, v]) => {
        if (!isNaN(v)) v = Number(v);
        else if (v.toLowerCase() === 'true') v = true;
        else if (v.toLowerCase() === 'false') v = false;
        return [k, v];
      })
    );

    let defaultOptions = {
      allowPreSearch: false,
      filterAutoSubmit: false,
      filterDrawerCloseText: 'Close',
      filterDrawerToggleText: 'Filter Results',
      filterParentsExcludeChildren: false,
      filterInitiallyExpanded: 'false',
      filterSubmitText: 'Apply',
      hideRail: false,
      maxPaginationItems: null,
      openInNewWindow: true,
      pageLength: 10,
      paginationUsesHistory: false,
      preserveResults: false,
      queryAllowAutocomplete: null,
      queryPlaceholderText: 'Search keyword or phrase',
      queryRequired: false,
      queryStringKeyQuery: 'query',
      queryStringKeyFilters: 'filters',
      queryStringKeyPage: 'page',
      querySubmitText: 'Search',
      resetText: 'Reset',
      resultsLabelTemplate: 'Results {start} - {end} of {total}',
      scrollOnReload: true,
      showFilters: true,
      showFiltersCount: true,
      showQuery: true,
      showReset: false,
      showSort: true,
      showTags: true,
      sortText: 'Sort by',
      transitionOnReload: true,
      noResultsText:
        'Sorry, there were no results found for your search. Please try again.',
    };

    options = defaults(options, defaultOptions);

    Vue.mixin({
      data() {
        return {
          options,
        };
      },
    });

    Vue.component('SearchQuery', SearchQuery);
    Vue.component('SearchFilters', SearchFilters);
    Vue.component('SearchTags', SearchTags);
    Vue.component('SearchResults', SearchResults);
    Vue.component('SearchPagination', SearchPagination);

    Vue.component('BlueSearch', BlueSearchApp);
  },
};

export { plugin as BlueSearch, store };
